import { render } from "./Proadvisor.vue?vue&type=template&id=45916020&scoped=true"
import script from "./Proadvisor.vue?vue&type=script&lang=js"
export * from "./Proadvisor.vue?vue&type=script&lang=js"

import "./Proadvisor.vue?vue&type=style&index=0&id=45916020&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45916020"]])

export default __exports__